import React from "react";
import { useEffect } from "react";
import SignInSide from "./components/SignInSide.js";
import Dashboard from "./components/Dashboard.js";
import Venue from "./components/Venue.js";
import Instructor from "./components/Instructor.js";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import VenueMain from "./components/venue/VenueMain.js";
import InstructorMain from "./components/instructor/InstructorMain.js";
import CourseMain from "./components/course/CourseMain.js";
import AdvertisementMain from "./components/Advertisement/AdvertisementMain.js";
import ADCalendarMain from "./components/ADcalendar/ADCalendarMain.js";
import ADCalendarAHAMain from "./components/ADcalendar/ADCalendarAHAMain.js";
import ReportMain from "./components/reports/ReportMain.js";
import KBArticlesMain from "./components/KBArticle/KBArticleMain.js";
import CourseRecordMain from "./components/CourseRecord/CourseRecordMain.js";
import RepostMain from "./components/repost/RepostMain.js";
import ManagementMain from "./components/register/ManagementMain.js";
import ProposalCalendarPage from "./components/calendar/ProposalCalendarPage.js";
import { initializeSessionActivityTracker } from "./components/AxiosInstance.js";
function App() {
  useEffect(() => {
    const cleanup = initializeSessionActivityTracker();
    return cleanup;
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<SignInSide />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/venue" element={<Venue />} />
        <Route path="/instructor" element={<Instructor />} />
        <Route path="/venuemain" element={<VenueMain />} />
        <Route path="/instructormain" element={<InstructorMain />} />
        <Route path="/coursemain" element={<CourseMain />} />
        <Route path="/advertisementmain" element={<AdvertisementMain />} />
        <Route path="/ADCalendarMain" element={<ADCalendarMain />} />
        <Route path="/ADCalendarAHAMain" element={<ADCalendarAHAMain />} />
        <Route path="/ReportMain" element={<ReportMain />} />
        <Route path="/KBArticlesMain" element={<KBArticlesMain />} />
        <Route path="/CourseRecordMain" element={<CourseRecordMain />} />
        <Route path="/Repost" element={<RepostMain />} />
        <Route path="/management" element={<ManagementMain />} />
        <Route path="/calendar/availability" element={<ProposalCalendarPage />} />
      </Routes>
    </Router>
  );
}

export default App;
